<template>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-white">
                E-Book
            </h2>
        </template>
            <div class="w-full p-12 text-gray-700 bg-white rounded shadow-xl">
                <div class="md:flex md:justify-between md:mb-4">
                    <div class="flex flex-col justify-between w-full md:pr-4">
                        <div>
                            <!-- book title -->
                            <div class="mb-4 text-3xl font-bold">
                                {{ ebook.title }}
                                <span v-if="ebook.is_paid == 1">(paid - {{ product.price }} COIN)</span>
                                <span v-if="ebook.is_paid == 0">(free)</span>
                            </div>
                            <!-- description -->
                            <div class="mb-4">
                                <div class="w-full">
                                    <div class="text-base font-bold text-gray-700">Description</div>
                                    <div class="mt-2">{{ ebook.description }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- pdf -->
                        <div>
                            <a :href="`/img/ebooks/pdf/${ebook.pdf_url}`" target="_blank">
                                <button class="flex items-center px-8 py-1 font-bold text-white bg-blue-600 border-2 rounded-md hover:text-blue-600 hover:bg-white hover:border-blue-600">
                                    View PDF
                                </button>
                            </a>
                        </div>
                    </div>
                    <!-- cover image -->
                    <div class="w-full" style="text-align: -webkit-center;">
                        <img :src="ebook.cover_photo_url" alt="cover_image" class="w-80">
                    </div>
                </div>
            </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        props: ['ebook', 'product'],
        components: {
            AdminLayout,
        },
        data() {
            return {}
        },
    };
</script>